<!-- Форма фиксирует способ и комментарий проверки заказ-наряда ремонта. -->
<template>
  <form
    :id="formId"
    class="inspection-form"
    @submit.prevent="handleSubmit"
  >
    <BaseFormField
      label="Способ проверки"
      for-id="repair_inspection_method"
      required
      :filled="isFieldFilled('inspection_method_item_id')"
      :error="errors.inspection_method"
    >
      <ReferenceItemSelect
        id="repair_inspection_method"
        v-model="formData.inspection_method_item_id"
        target-model="Fleet::Repair"
        target-field="inspection_method"
        button-label="Добавить способ"
        placeholder="Выберите способ проверки"
        :with-button="true"
        :clearable="false"
        @update:model-value="errors.inspection_method = false"
      />
    </BaseFormField>

    <BaseFormField
      label="Комментарий проверки"
      for-id="repair_inspection_comment"
      :filled="isFieldFilled('inspection_comment')"
    >
      <base-textarea
        id="repair_inspection_comment"
        v-model="formData.inspection_comment"
        placeholder="Что проверили и какие замечания есть"
      />
    </BaseFormField>
  </form>
</template>

<script>
import { useFleetRepairStore } from "@/stores/fleetRepairStore";
import { useNotificationStore } from "@/stores/notificationStore";

import ReferenceItemSelect from "@/components/ReferenceItem/ReferenceItemSelect.vue";

export default {
  name: "FleetRepairInspectionForm",

  components: {
    ReferenceItemSelect,
  },

  props: {
    repairId: {
      type: Number,
      required: true,
    },
    formId: {
      type: String,
      required: true,
    },
  },

  emits: ["confirmed"],

  data() {
    return {
      formData: {
        inspection_method_item_id: null,
        inspection_comment: "",
      },
      errors: {
        inspection_method: false,
      },
    };
  },

  computed: {
    repairStore() {
      return useFleetRepairStore();
    },

    notificationStore() {
      return useNotificationStore();
    },
  },

  methods: {
    isFieldFilled(field) {
      return Boolean(this.formData[field]);
    },

    validateForm() {
      this.errors.inspection_method =
        !this.formData.inspection_method_item_id;

      if (this.errors.inspection_method) {
        this.notificationStore.showError("Выберите способ проверки");
      }

      return !this.errors.inspection_method;
    },

    async handleSubmit() {
      if (!this.validateForm()) return;

      const repair = await this.repairStore.confirmInspection(
        this.repairId,
        {
          inspection_method_item_id:
            this.formData.inspection_method_item_id,
          inspection_comment: this.formData.inspection_comment || null,
        }
      );

      this.$emit("confirmed", repair);
    },
  },
};
</script>

<style scoped>
.inspection-form {
  display: flex;
  flex-direction: column;
  gap: var(--base-in-indent);
}
</style>
